import http from '@/common/api/http'

export const goodsSearch = (data) => {
    return http.post(`/gylm/pinduoduo/v1/GoodsSearch`, data);
};
